<template>
    <ul class="menu-full">
        <li class="menu-category" v-for="category in computedMenu" :key="category.category_id" ref="itemRefs"
            :id="category.id">
            <div class="menu-category-name">{{ category.name }}</div>
            <p v-if="category.description" class="menu-category-description">
                {{ category.description }}
            </p>
            <ul>
                <MenuItem v-for="item in filteredItems(category)" :item="item" :key="item.id" />
            </ul>
            <div v-for="subcategory in category.subcategories" class="menu-subcategory" :key="subcategory.category_id">
                <p class="menu-subcategory-name">{{ subcategory.name }}</p>
                <ul>
                    <MenuItem v-for="item in subcategory.items" :item="item" :key="item.id" />
                </ul>
            </div>
        </li>
    </ul>
</template>

<script>
import MenuItem from "./MenuItem.vue";

export default {
    name: "MenuInfScroll",
    components: {
        MenuItem,
    },
    data() {
        return {
            observer: null,
        };
    },
    mounted() {
        this.$store.dispatch('menuStore/GET_FULL_MENU')
            .then(() => this.menuLoaded());
    },
    computed: {
        computedMenu() {
            return this.$store.getters['menuStore/getMenu'] || [];
        }
    },
    methods: {
        menuLoaded() {
            this.$nextTick(() => {
                const res = this.$refs.itemRefs || [];
                this.$emit("loadedItems", res);
            });
        },
        filteredItems(category) {
            let res = category.items;

            if (category.subcategories.length !== 0) {
                const subItems = category.subcategories.reduce((arr, val) => {
                    return arr.concat(val.items);
                }, []);

                res = category.items.filter(item => {
                    return !subItems.some(subItem => subItem.category_id === item.category_id);
                });
            }

            return res;

        }

    }
}
</script>

<style lang="scss" scoped>
@import "/src/scss/assets/variables";

ul {
    list-style-type: none;
    padding: 0;
    margin: 0;

}

.menu-category {
    padding-top: 16px;
    scroll-margin-top: 50px;
}

.menu-category-name {
    margin: 10px 0;

    font-weight: 590;
    font-size: 22px;
    line-height: 100%;

    color: black;
}

.menu-subcategory-name {
    margin: 20px 0 10px;

    font-weight: 510;
    font-size: 14px;
    line-height: 100%;

    color: black;
}

.menu-category-description {
    margin: 10px 0;
    padding: 12px;

    font-family: Poppins;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    text-align: center;

    border: 1px solid #EDEDED;
    border-radius: 12px;

    color: black;
    background-color: $color_white_titan;
}
</style>